export const widthOptions = [
    { id: 1, label: '0px'},
    { id: 2, label: '1px'},
    { id: 3, label: '2px'},
    { id: 4, label: '3px'},
    { id: 5, label: '4px'},
    { id: 6, label: '5px'}
  ];